<template>
  <div class="msg-background">
    <div class="container">
      <img src="@/assets/images/popup-error-image.png" alt="Kidjo TV" class="popup-image">
      <div class="title" v-if="isNotificationVisible.title">
        {{ getTranslatedString(isNotificationVisible.title) }}
      </div>
      <div class="message" v-if="isNotificationVisible.message">
        {{ getTranslatedString(isNotificationVisible.message) }}
      </div>
      <div
        v-if="isNotificationVisible.closeButton"
        class="ok-button-container"
        @click="popupClose"
      >
        <button class="btn_ok">
          {{ getTranslatedString('confirmation_ok') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { soundList, soundPlayer } from '@/utils/sounds';
import langUtil from '@/utils/lang.util';

export default {
  computed: {
    isNotificationVisible() {
      return this.$store.getters['settings/getNotificationVisibility']
    }
  },
  methods: {   
    popupClose() {
      soundPlayer(soundList.general);
      this.$store.dispatch("settings/setNotificationVisibility", {
        status: false,
        title: null,
        message: null,
        closeButton: true
      })
    },

    getTranslatedString(string){
      return langUtil.getLang().t(string)
    }
  }
}
</script>

<style lang="scss" scoped>

.msg-background {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 200;
  justify-content: center;
  justify-items: center;
  align-items: center;
  background: transparent;
  backdrop-filter: blur(11px);

  .container {
    position: relative;
    width: 30%;
    max-width: 980px;
    padding: 15px 15px 6px 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    color: #020076;
    background-color: white;
    border: 6px solid #020076;
    border-radius: 30px;

    @media (max-width: 768px) {
      max-width: 350px;
      width: 85%;
      height: auto;
      max-height: unset;
      padding: 20px 15px 6px 15px;

      &::before {
        display: none;
      }
    }

    @media (orientation: landscape) and (max-height: 360px) {
      top: 45px;
    }

    @media (orientation: landscape) and (max-height: 480px) {
      top: 20px;
      width: 250px;
      max-width: 525px;
      border-radius: 22px;
      border-width: 3px;
      max-height: 95%;
    }

    .popup-image{
      position: absolute;
      width: 150px;
      top: -140px;

      @media (max-width: 1024px) {
        width: 90px;
        top: -80px;
      }

      @media (max-width: 768px) {
        width: 90px;
        top: -75px;
      }

      @media (orientation: landscape) and (max-height: 480px) {
        width: 70px;
        top: -60px;
      }
    }

    .title {
      font-family: 'Nunito-ExtraBold', serif;
      font-size: 25px;
      display: flex;
      padding: 10px 0;

      @media (min-width: 1090px) {
        font-size: 45px;
      }

      @media (max-width: 768px) {
        font-size: 28px;
      }

      @media (max-height: 480px) {
        font-size: 25px;
      }
    }

    .message {
      font-family: 'Nunito-Regular', serif;
      font-size: 20px;
      padding-bottom: 15px;

      @media (max-width: 1024px) {
        font-size: 18px;
      }

      @media (max-width: 768px) {
        font-size: 21px;
        line-height: 1.2;
      }

      @media (orientation: landscape) and (max-height: 480px) {
        line-height: 1.1;
        padding-bottom: 10px;
      }
  
      @media (max-height: 480px) {
        font-size: 16px;
      }
    }

    .ok-button-container {
      background-color: white;
      border-radius: 20px;
      margin-bottom: 15px;

      &.active {
        animation: pulse_button 1.5s infinite;
      }

      &:hover,
      &:focus {
        animation: pulse_button 1.5s infinite;

        @keyframes pulse_button {
          0% {
            -webkit-transform: scale(0.95);
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
          }
          70% {
            -webkit-transform: scale(1);
            transform: scale(1);
            box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
          }
          100% {
            -webkit-transform: scale(0.95);
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
          }
        }
      }

      @media (orientation: landscape) and (max-height: 480px) {
        margin-bottom: 10px;
      }
    }

    .btn_ok {
      max-width: fit-content;
      padding: 10px 50px;
      background: #FFA726;
      border-radius: 20px;
      color: #020076;
      font-family: 'Nunito-ExtraBold';
      font-size: 20px;
      display: inline-block;
      cursor: pointer;
      text-align: center;
      border: none;

      @media (max-width: 1024px) {
        font-size: 16px;
        padding: 10px 30px;
      }

      @media (max-height: 300px) {
        font-size: 14px;
      }
    }
  }
}

</style>
